import { motion, AnimatePresence } from "framer-motion";

const STARS = Array.from({ length: 20 }, () => ({
  top: `${5 + Math.random() * 45}%`,
  left: `${Math.random() * 100}%`,
}));

function Star({ style }) {
  return (
    <motion.div
      className="absolute w-0.5 h-0.5 bg-white rounded-full"
      style={style}
      animate={{ opacity: [0.2, 1, 0.2] }}
      transition={{ duration: 2 + Math.random() * 3, repeat: Infinity, delay: Math.random() * 3 }}
    />
  );
}

export function VillageScene({ isNight, players = [], compact = false, onOpenDead }) {
  const alive = players.filter(p => p.alive);
  const village = alive.filter(p => p.effectiveAlignment === "village");
  const wolves  = alive.filter(p => p.effectiveAlignment === "werewolf");
  const neutral = alive.filter(p => p.effectiveAlignment === "neutral");

  return (
    <div className={`relative w-full ${compact ? "h-28" : "h-40"} rounded-2xl overflow-hidden border border-amber-900/20`}>
      <AnimatePresence>
        {isNight ? (
          <motion.img
            key="night"
            src="/village/bg-night.png"
            className="absolute inset-0 w-full h-full object-cover"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          />
        ) : (
          <motion.img
            key="day"
            src="/village/bg-day.png"
            className="absolute inset-0 w-full h-full object-cover"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isNight && STARS.map((s, i) => <Star key={i} style={s} />)}
      </AnimatePresence>

      <AnimatePresence>
        {isNight ? (
          <motion.img
            key="moon"
            src="/village/moon.png"
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -40, opacity: 0 }}
            transition={{ duration: 1.8, ease: "easeOut" }}
            className="absolute top-2 right-5 w-9 h-9"
          />
        ) : (
          <motion.img
            key="sun"
            src="/village/sun.png"
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -40, opacity: 0 }}
            transition={{ duration: 1.8, ease: "easeOut" }}
            className="absolute top-1 right-5 w-9 h-9"
          />
        )}
      </AnimatePresence>

      {/* <motion.div
        className="absolute bottom-0 left-0 right-0 h-14"
        animate={{ background: isNight
          ? "linear-gradient(to top, #071005, #0c1a08)"
          : "linear-gradient(to top, #1a3d12, #2d5a20)" }}
        transition={{ duration: 2.5 }} /> */}

      {/* Village silhouette placeholder */}
      <img src="/village/houses.png" className="absolute bottom-5 left-1/2 -translate-x-1/2 w-64 h-auto" />

      {/* Campfire placeholder */}
      <img src="/village/campfire.gif" className="absolute bottom-4 left-1/2 -translate-x-1/2 w-8 h-8" />

      <div className="absolute bottom-2 left-2 flex flex-wrap gap-1 max-w-[38%]">
        {village.slice(0, 8).map(p => (
          <motion.div key={p.id} initial={{ scale: 0 }} animate={{ scale: 1 }}
            className="w-5 h-5 rounded-full bg-emerald-800 border border-emerald-500
              flex items-center justify-center text-[9px]" title={p.name}>
            {p.name[0].toUpperCase()}
          </motion.div>
        ))}
      </div>

      <div className="absolute bottom-2 right-2 flex flex-wrap gap-1 max-w-[38%] justify-end">
        {wolves.slice(0, 5).map(p => (
          <motion.div key={p.id} initial={{ scale: 0 }} animate={{ scale: 1 }}
            className="w-5 h-5 rounded-full bg-red-900 border border-red-600
              flex items-center justify-center text-[9px]" title={p.name}>
            {p.name[0].toUpperCase()}
          </motion.div>
        ))}
      </div>

      {neutral.length > 0 && (
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
          {neutral.map(p => (
            <motion.div key={p.id} initial={{ scale: 0 }} animate={{ scale: 1 }}
              className="w-5 h-5 rounded-full bg-teal-900 border border-teal-500
                flex items-center justify-center text-[9px]" title={p.name}>
              {p.name[0].toUpperCase()}
            </motion.div>
          ))}
        </div>
      )}

      {players.filter(p => !p.alive).length > 0 && (
        <button onClick={onOpenDead}
          className="absolute top-2 left-2 text-[10px] text-slate-400/80 bg-black/40
            rounded px-1.5 py-0.5 active:scale-95 transition-all border border-slate-700/20">
          💀 {players.filter(p => !p.alive).length}
        </button>
      )}
    </div>
  );
}
